import React from "react";
import { Route, Redirect } from "react-router-dom";
import { useSelector } from "react-redux";

export const PrivateRoute = ({ component: Component, roles, ...rest }) => {
  const currentUser = useSelector((state) => state.auth.currentUser);
  const isLoggedIn = currentUser && currentUser.access_token;

  // not logged in, redirect to login page
  if (!isLoggedIn) {
    return (
      <Redirect to={{ pathname: "/login", state: { from: rest.location } }} />
    );
  }

  // check for role restricted routes
  if (roles && roles.indexOf(currentUser.role) === -1) {
    /* TODO: redirect to unauthorized page */
    return <Redirect to={{ pathname: "/login" }} />;
  }

  return <Route {...rest} component={Component} />;
};
